import { useEffect, useState } from 'react';

import { TESTIMONIALS } from '../../const';
import TestimonialsCarousel from './TestimonialsCarousel';
import TestimonialsCard from './TestimonialsCard';

import './testimonials.scss';

const Testimonials = () => {
  const [screenWidth, setScreenWidth] = useState(0);
  const [isCarouselShown, setCarouselShown] = useState(false);

  const onSetPageWidth = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', onSetPageWidth);
    return () => {
      window.removeEventListener('resize', onSetPageWidth);
    };
  });

  useEffect(() => {
    if (!screenWidth) {
      onSetPageWidth();
    } else {
      if (screenWidth <= 1024 && isCarouselShown) setCarouselShown(false);
      if (screenWidth > 1024 && !isCarouselShown) setCarouselShown(true);
    }
  }, [screenWidth, isCarouselShown]);

  return (
    <section className="testimonials-section">
      <div className="testimonials-section__heading">
        <div>
          <h2>
            <strong>Clients’</strong> testimonials
          </h2>
          <p>
            Our clients often come to us through recommendations, which is a
            good indicator of our services
          </p>
        </div>
        <p className="testimonials-section__heading-uppercase">
          Trusted partnership
        </p>
      </div>
      {!isCarouselShown ? (
        <ul className="testimonialsCarousel">
          {TESTIMONIALS.map((item) => (
            <li key={item.id} className="testimonialsCarousel__card">
              <TestimonialsCard item={item} />
            </li>
          ))}
        </ul>
      ) : (
        <div className="testimonialsCarousel__wrapper">
          <TestimonialsCarousel>
            {TESTIMONIALS.map((item) => (
              <div key={item.id} className="testimonialsCarousel__card">
                <TestimonialsCard item={item} />
              </div>
            ))}
          </TestimonialsCarousel>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
